module.exports = __webpack_public_path__ + "img/content.ebbf5640.png";